import * as React from "react";
const PhotoNotPaidIcon = (props) => (
  <svg
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    x={0}
    y={0}
    viewBox="0 0 25 25"
    style={{
      enableBackground: "new 0 0 50 50",
    }}
    xmlSpace="preserve"
    width={25}
    height={25}
    {...props}
  >
    <style>{".st0{fill:#242426}"}</style>
    <path
      className="st0"
      d="M20 20.595H5c-1.105 0 -2 -0.895 -2 -2V8.625c0 -1.105 0.895 -2 2 -2h15c1.105 0 2 0.895 2 2v9.97c0 1.105 -0.895 2 -2 2z"
    />
    <path className="st0" d="M17.17 7.675H7.83l2.5 -3.27h4.34z" />
    <path
      cx={25}
      cy={27.4}
      r={6.98}
      style={{
        fill: "none",
        stroke: "#fff",
        strokeWidth: 3,
        strokeMiterlimit: 10,
      }}
      d="M15.99 13.7A3.49 3.49 0 0 1 12.5 17.19A3.49 3.49 0 0 1 9.01 13.7A3.49 3.49 0 0 1 15.99 13.7z"
    />
    <path
      cx={37.97}
      cy={18.58}
      r={1.94}
      style={{
        fill: "#fff",
      }}
      d="M19.955 9.29A0.97 0.97 0 0 1 18.985 10.26A0.97 0.97 0 0 1 18.015 9.29A0.97 0.97 0 0 1 19.955 9.29z"
    />
  </svg>
);
export default PhotoNotPaidIcon;
